import TableAction from './TableAction';

export default TableAction;
